import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";
import {
  ProductTemplateDeleteParametersType,
  ProductTemplateListParametersType,
} from "@sellar-io/api-v2/types";

export const useProductTemplateDeleteMany = (
  parameters: ProductTemplateListParametersType,
) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: ProductTemplateDeleteParametersType) =>
      apiV2Request({
        user,
        business,
        method: "delete",
        path: `product-template/delete-many`,
        data,
      }),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.ProductTemplate,
          parameters,
        ],
      });
    },
  });
};
